import { render, staticRenderFns } from "./userCard.vue?vue&type=template&id=254baba2&scoped=true"
import script from "./userCard.vue?vue&type=script&lang=js"
export * from "./userCard.vue?vue&type=script&lang=js"
import style0 from "./userCard.vue?vue&type=style&index=0&id=254baba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254baba2",
  null
  
)

export default component.exports